//
import { normalize } from 'normalizr';
import { browserHistory } from 'react-router';

import { simplApi } from '../../api/simplApi';
import { person } from './schemas';

import { receiveFile } from './file';
import { receiveActivity } from './activity';
import { fetchTotalData } from './totaldata';
import { receiveCompany } from './company';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';
import moment from 'moment/moment';
import getBirthdayFromMeta from '../../helpers/getBirthdayFromMeta';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_PERSON = 'REQUEST_PERSON';
export const RECEIVE_PERSON = 'RECEIVE_PERSON';
export const SET_PERSON = 'SET_PERSON';
export const SET_PERSON_FORM = 'SET_PERSON_FORM';
export const CLOSE_PERSON_FORM = 'CLOSE_PERSON_FORM';
export const REMOVE_PERSON = 'REMOVE_PERSON';

// ------------------------------------
// Actions
// ------------------------------------

export function requestPerson() {
  return {
    type: REQUEST_PERSON,
  };
}

export function receivePerson(persons) {
  return {
    type: RECEIVE_PERSON,
    payload: {
      persons,
    },
  };
}

export function setPerson(personId) {
  return {
    type: SET_PERSON,
    payload: personId,
  };
}

export function setPersonForm(personId = 0) {
  return {
    type: SET_PERSON_FORM,
    payload: personId,
  };
}

export function closePersonForm() {
  return {
    type: CLOSE_PERSON_FORM,
  };
}

export const fetchPerson = personId => dispatch => {
  dispatch(requestPerson());

  const url =
    typeof personId !== 'undefined' && personId !== null
      ? `person/${personId}`
      : 'person';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedPersons;

        if (typeof json.id === 'undefined') {
          preparedPersons = normalize(json, [person]);
        } else {
          preparedPersons = normalize(json, person);
        }

        dispatch(receivePerson(preparedPersons.entities.persons));
        dispatch(receiveActivity(preparedPersons.entities.activities));
        dispatch(receiveCompany(preparedPersons.entities.companies));
        dispatch(receiveFile(preparedPersons.entities.files));
      }
    });
};

export const fetchPersonGoogleImport = () => dispatch => {
  dispatch(requestPerson());

  const url = 'person/import/google';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        return json;
      }
    });
};

export function removePerson(personId) {
  return {
    type: REMOVE_PERSON,
    payload: personId,
  };
}

export const deletePerson = personId => dispatch => {
  const url = `person/${personId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removePerson(personId));
        dispatch(addFeedback('warning', 'Kontakt gelöscht'));
      }
    });
};

export const savePerson = (newPerson, redirect = true) => dispatch => {
  dispatch(requestPerson());

  let url = 'person/';
  const options = { method: 'post', body: newPerson };
  if (typeof newPerson.id !== 'undefined' && newPerson.id !== null) {
    url = `${url}${newPerson.id}`;
    options.method = 'put';
  }

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!', json);
        }

        dispatch(handleApiError(json));
      } else {
        const preparedPersons = normalize(json, person);

        dispatch(receivePerson(preparedPersons.entities.persons));

        dispatch(fetchTotalData());

        dispatch(addFeedback('success', 'Kontakt gespeichert'));

        if (redirect) {
          browserHistory.push(`/person/${json.id}`);
        } else {
          return json;
        }
      }
    });
};

export const actions = {
  requestPerson,
  receivePerson,
  setPersonForm,
  closePersonForm,
  fetchPerson,
  fetchPersonGoogleImport,
  setPerson,
  savePerson,
  deletePerson,
  removePerson,
};

const PERSON_ACTION_HANDLERS = {
  [REQUEST_PERSON]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_PERSON]: (state, action) => ({ ...state, current: action.payload }),
  [SET_PERSON_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_PERSON]: (state, action) => ({
    ...state,
    persons: _.omit(state.persons, action.payload),
  }),
  [CLOSE_PERSON_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_PERSON]: (state, action) => {
    const statePersons = Object.assign({}, state.persons);
    const birthdays = Object.assign({}, state.birthdays);

    // // console.log('receiving persons in reducer', action.payload.persons)

    _.forOwn(action.payload.persons, (_person, id) => {
      const newPerson = _.cloneDeep(_person);

      const newMeta = {};

      _.forOwn(_person.meta, value => {
        newMeta[value.key] = value;

        if (value.key === 'date_of_birth') {
          const birthday = getBirthdayFromMeta(_person.meta, false);
          if (birthday) {
            newMeta[value.key].value = birthday.format('DD.MM.YYYY');
            birthday.year(moment().year());
            newMeta[value.key].birthdayAsDate = birthday.toDate();
            newMeta[value.key].birthdayEndAsDate = birthday
              .add(1, 'days')
              .toDate();
          }
        }
      });

      newPerson.meta = newMeta;

      if (
        typeof newPerson.companies !== 'undefined' &&
        newPerson.companies.length
      ) {
        // there are companies, lets test them
        if (typeof newPerson.companies[0].id !== 'undefined') {
          // companies are objects, need to extract their ID to make an array of IDs
          const newCompanies = [];
          _.forOwn(newPerson.companies, company => {
            newCompanies.push(company.id);
          });
          newPerson.companies = newCompanies;
        }
      }

      if (typeof statePersons[id] === 'object') {
        Object.assign(statePersons[id], statePersons[id], newPerson);
      } else {
        statePersons[id] = newPerson;
      }

      if (
        newMeta.date_of_birth &&
        newMeta.date_of_birth.value !== null &&
        newMeta.date_of_birth.value.length &&
        newPerson.deleted_at === null
      ) {
        let birthday = moment(newMeta.date_of_birth.value, 'DD.MM.YYYY');
        if (!birthday.isValid()) {
          birthday = moment(newMeta.date_of_birth.value, 'YYYY-MM-DD');
        }

        const day = birthday.format('DD.MM');

        if (Array.isArray(birthdays[day])) {
          if (!birthdays[day].includes(id)) {
            birthdays[day].push(id);
          }
        } else {
          birthdays[day] = [id];
        }

        if (Array.isArray(birthdays['all'])) {
          if (!birthdays['all'].includes(id)) {
            birthdays['all'].push(id);
          }
        } else {
          birthdays['all'] = [id];
        }
      }
    });

    return {
      ...state,
      persons: _.cloneDeep(statePersons),
      birthdays,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  persons: {},
  birthdays: {},
};
export default function personReducer(state = initialState, action) {
  const handler = PERSON_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/person.js